<template>
  <span>
    <v-card flat>
      <v-btn icon :disabled="images.length < 1 || sending" @click="uploadFile" :color="outboxColor" large flat>
        <v-badge v-model="showOutboxCount" left overlap color="orange">
          <span slot="badge">{{imageCount}}</span>
          <v-icon x-large>file_upload</v-icon>
        </v-badge>
      </v-btn>
      <p class="text-xs-center">Empty Outbox</p>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="6000">
      {{snackbarText}}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </span>
</template>

<script>
import dbPromise from '../dbPromise'
import { storage, fireStore } from '../firebase'
import moment from 'moment'

export default {
  data () {
    return {
      images: [],
      sending: !!sessionStorage.getItem('isSending'),
      snackbar: false,
      snackbarText: ''
    }
  },
  computed: {
    imageCount () {
      return this.images.length
    },
    showOutboxCount () {
      return this.images.length > 0
    },
    outboxColor () {
      if (this.sending) {
        return 'green'
      } else {
        return 'secondary'
      }
    },
    customers () {
      return this.$store.getters.customers
    }
  },
  mounted () {
    this.getImages()
    this.uploadFile()
  },
  watch: {
    customers (val) {
      if (val.length) {
        this.uploadFile()
      }
    }
  },
  methods: {
    getImages () {
      dbPromise().then(function (db) {
        let tx = db.transaction('outbox')
        let outboxStore = tx.objectStore('outbox')
        return (outboxStore.getAll())
      }).then((val) => {
        this.images = val
      })
    },
    uploadFile () {
      if (!this.customers.length) {
        return
      }
      // get keys to items in outbox
      dbPromise().then(function (db) {
        let tx = db.transaction('outbox')
        let outboxStore = tx.objectStore('outbox')
        return (outboxStore.getAllKeys())
      }).then((keys) => {
        if (keys.length > 0) {
          if (sessionStorage.getItem('isSending') === 'true') {
            this.snackbar = true
            this.snackbarText = 'Sending Already In Progress'
            return
          }
          this.sending = true
          sessionStorage.setItem('isSending', 'true')
          // if there are items in outbox try and send the first
          let element = keys[0]
          this.snackbar = true
          this.snackbarText = 'Sending Completed Jobs'
          // Get single outbox item
          dbPromise().then(function (db) {
            return db.transaction('outbox').objectStore('outbox').get(element)
          }).then(async (val) => {
            // Call to jobs collection where customer = job customer
            // Store job numbers in array, strip customer prefix, reverse sort array
            // Latest job number is arr[0]
            // Add 1, add customer prefix to get job number
            // Create empty job doc with this job number to 'reserve' the job number to avoid duplicates being created elsewhere
            console.log(val)
            let job = val
            const customerIndex = this.customers.findIndex(customer => {
              return job.Customer === customer.id
            })
            const shortName = this.customers[customerIndex]['shortName']

            if (!job.JobNo) {
              let jobNumbers = await this.getJobNumbers(job.Customer, shortName)
              job.JobNo = shortName + this.zeroFill(parseInt(jobNumbers[0]) + 1, 4)
            }
            console.log(job)
            if (!job.unscheduled) {
              job.unscheduled = 0
            }
            if (!job.Date) {
              job.Date = moment().format('YYYY-MM-DD')
            }
            if (job.vehicle === undefined || job.vehicle === '' || job.vehicle === null) {
              job.vehicle = job.reg
            }
            if (job.imei === undefined || job.imei === null) {
              job.imei = ''
            }
            this.next(job.number, job, element)
          })
        } else {
          this.sending = false
          this.snackbarText = 'Nothing To Do'
          sessionStorage.removeItem('isSending')
        }
      })
    },
    getJobNumbers (customer, shortName) {
      return fireStore.collection('Jobs').where('Customer', '==', customer).get()
      .then(snap => {
        let jobNumbers = []
        snap.forEach(doc => {
          let JobNo = doc.data().JobNo
          if (JobNo && JobNo.indexOf(shortName) > -1) { // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
            JobNo = JobNo.replace(/\D/g, '')
            jobNumbers.push(JobNo)
          }
        })
        return jobNumbers.sort((a, b) => {
          return b - a
        })
      })
    },
    // next (doc, job, element) { //OLD UPLOAD PROCESS
    //   let val = job
    //   let toDelete = []
    //   for (let template in val.template) {
    //     for (let item in val.template[template].items) {
    //       if (val.template[template].items[item].image !== '') {
    //         toDelete.push(val.template[template].items[item].image)
    //         dbPromise().then(function (db) {
    //           let tx = db.transaction('imageStore')
    //           let imageStore = tx.objectStore('imageStore')
    //           return (imageStore.get(val.template[template].items[item].image))
    //         })
    //         .then((image) => {
    //           if (image !== undefined) {
    //             // Prepare image for sending
    //             let bytes = image.image
    //             let ref = storage.ref(job.JobNo + '/' + image.name)
    //             this.sending++
    //             // Send image
    //             console.info('Sending image')
    //             ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
    //             .then((snapshot) => {
    //               job.template[template].items[item].image = snapshot.downloadURL
    //               // Image has been successful so safe to remove from IDB
    //               // On successful removal change flag and check if anything is still sending
    //               this.sending--
    //               console.log(this.sending)
    //               if (this.sending === 0) {
    //                 // If all images have been sent -> send data
    //                 fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
    //                 .set(job)
    //                 .then(() => {
    //                   fireStore.collection('Jobs/').doc(doc).update({Status: 2})
    //                   // Data has been successful so safe to remove from IDB
    //                   dbPromise().then(function (db) {
    //                     let tx = db.transaction('outbox', 'readwrite')
    //                     let outboxStore = tx.objectStore('outbox')
    //                     outboxStore.delete(parseInt(element))
    //                   }).then(() => {
    //                     this.snackbar = true
    //                     this.snackbarText = 'Upload Successful'
    //                     this.getImages()
    //                     for (let i in toDelete) {
    //                       dbPromise().then(function (db) {
    //                         let tx = db.transaction('imageStore', 'readwrite')
    //                         let imageStore = tx.objectStore('imageStore')
    //                         imageStore.delete(toDelete[i])
    //                       })
    //                     }
    //                     this.uploadFile()
    //                     this.snackbar = true
    //                     this.snackbarText = 'Finished Sending'
    //                   })
    //                   .catch(error => {
    //                     console.log(error)
    //                     this.snackbarText = 'Error updating status'
    //                     this.snackbar = true
    //                   })
    //                 })
    //                 .catch(error => {
    //                   console.log(error)
    //                   this.snackbarText = 'Error setting completed job'
    //                   this.snackbar = true
    //                 })
    //               }
    //             })
    //             .catch((error) => {
    //               this.sending--
    //               console.log(error)
    //               this.snackbarText = 'Unable to send. Will try later'
    //               this.snackbar = true
    //             })
    //           }
    //         })
    //       }
    //     }
    //   }
    // },
    async next (doc, job, element) {
      try {
        for (let template in job.template) {
          for (let item in job.template[template].items) {
            let image = job.template[template].items[item].image
            let imageName = job.template[template].items[item].imageName
            if (image && !imageName) {
              let imageObj = await this.uploadImage(job, image)
              job.template[template].items[item].image = imageObj.ref
              job.template[template].items[item].imageName = imageObj.name
              let updateSuccess = await this.updateLocalJob(job, element)
              if (updateSuccess) {
                let deleteImageStatus = await this.deleteImageFromDB(image)
                if (!deleteImageStatus) {
                  throw new Error('Could not remove images')
                }
              } else {
                throw new Error('Could not save state')
              }
            }
          }
        }
      } catch (error) {
        alert('Failed to complete step 1 - Job not uploaded. Please attempt via outbox.')
        this.snackbar = true
        this.snackbarText = error.message
        this.sending = false
        sessionStorage.removeItem('isSending')
        return
      }
      const clean = (object) => {
        Object
          .entries(object)
          .forEach(([k, v]) => {
            if (v && typeof v === 'object') {
              clean(v)
            }
            if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined) {
              if (Array.isArray(object)) {
                object.splice(k, 1)
              } else {
                delete object[k]
              }
            }
          })
        return object
      }
      let template = await clean(job.template || [])
      const obj = {
        Date: job.Date,
        JobNo: job.JobNo,
        Customer: job.Customer,
        imei: job.imei,
        template: template,
        unscheduled: job.unscheduled,
        Vehicle: job.vehicle,
        vehicle: job.reg ? job.reg : '',
        CompletedDate: job.CompletedDate,
        startTime: job.startTime || null,
        endTime: job.endTime || null,
        notes: job.notes || null,
        chargeable: job.chargeable || null
      }
      fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
      .set(obj)
      .then(() => {
        fireStore.collection('Jobs/').doc(doc).update({Status: 2, CompletedDate: job.CompletedDate, notes: job.notes || null, chargeable: job.chargeable || null})
        // Data has been successful so safe to remove from IDB
        dbPromise().then(function (db) {
          let tx = db.transaction('outbox', 'readwrite')
          let outboxStore = tx.objectStore('outbox')
          outboxStore.delete(parseInt(element))
        })
        .then(() => {
          this.getImages()
          this.uploadFile()
          this.snackbar = true
          this.snackbarText = 'Finished Sending'
          this.sending = false
          sessionStorage.removeItem('isSending')
        })
        .catch(() => {
          this.snackbar = true
          this.snackbarText = 'Failed to complete step 3 - Job not uploaded'
          this.sending = false
          sessionStorage.removeItem('isSending')
        })
      })
      .catch(() => {
        this.snackbar = true
        this.snackbarText = 'Failed to complete step 2 - Job not uploaded'
        this.sending = false
        sessionStorage.removeItem('isSending')
      })
    },
    uploadImage (job, image) {
      return dbPromise().then(function (db) {
        let tx = db.transaction('imageStore')
        let imageStore = tx.objectStore('imageStore')
        return (imageStore.get(image))
      })
      .then(async (image) => {
        if (image) {
          let bytes = image.image
          let ref = storage.ref(job.JobNo + '/' + image.name)
          let response = await ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
          return {ref: response, name: image.name, pathRef: ref}
        }
      })
      .then(async (snapshotObj) => {
        let downloadURL = await snapshotObj.pathRef.getDownloadURL()
        return {ref: downloadURL, name: snapshotObj.name}
      })
    },
    updateLocalJob (job, key) {
      return dbPromise().then((db) => {
        let tx = db.transaction('outbox', 'readwrite')
        let outboxStore = tx.objectStore('outbox')

        outboxStore.put(job, key)
        return tx.complete
      })
      .then(() => {
        return true
      })
      .catch(() => {
        return false
      })
    },
    deleteImageFromDB (key) {
      return dbPromise().then(function (db) {
        let tx = db.transaction('imageStore', 'readwrite')
        let imageStore = tx.objectStore('imageStore')
        imageStore.delete(key)
        return true
      })
      .catch(() => {
        return false
      })
    },
    // Upload process attempt 2
    // next (doc, job, element) {
    //   let val = job
    //   let toDelete = []
    //   let promises = []
    //   console.log(val.template)
    //   for (let template in val.template) {
    //     val.template[template].items.map((obj, item) => {
    //       promises.push(new Promise((resolve, reject) => {
    //         if (val.template[template].items[item].image !== '') {
    //           toDelete.push(val.template[template].items[item].image)
    //           dbPromise().then(function (db) {
    //             let tx = db.transaction('imageStore')
    //             let imageStore = tx.objectStore('imageStore')
    //             return (imageStore.get(val.template[template].items[item].image))
    //           })
    //           .then((image) => {
    //             if (image !== undefined) {
    //               // Prepare image for sending
    //               let bytes = image.image
    //               let ref = storage.ref(job.JobNo + '/' + image.name)
    //               // Send image
    //               console.info('Sending image')
    //               ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
    //               .then((snapshot) => {
    //                 job.template[template].items[item].image = snapshot.downloadURL
    //                 job.template[template].items[item].imageName = image.name
    //                 console.log('uploaded')
    //                 console.log(promises)
    //                 resolve('resolved')
    //                 // Image has been successful so safe to remove from IDB
    //                 // On successful removal change flag and check if anything is still sending
    //               })
    //               .catch((error) => {
    //                 console.log('rejected')
    //                 console.log(promises)
    //                 console.log(error)
    //                 reject('rejected')
    //               })
    //             }
    //           })
    //         } else {
    //           resolve('no image')
    //         }
    //       }))
    //     })
    //   }
    //   Promise.all(promises)
    //   .then(async value => {
    //     console.log(value)
    //     if (value.indexOf('rejected') > -1) {
    //       console.log('Image upload failed')
    //       this.snackbarText = 'Image upload failed. Please try again'
    //       this.snackbar = true
    //       return
    //     }
    //     const clean = (object) => {
    //       Object
    //         .entries(object)
    //         .forEach(([k, v]) => {
    //           if (v && typeof v === 'object') {
    //             clean(v)
    //           }
    //           if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined) {
    //             if (Array.isArray(object)) {
    //               object.splice(k, 1)
    //             } else {
    //               delete object[k]
    //             }
    //           }
    //         })
    //       return object
    //     }
    //     let template = await clean(job.template || [])
    //     console.log(job)
    //     const obj = {
    //       Date: job.Date,
    //       JobNo: job.JobNo,
    //       Customer: job.Customer,
    //       imei: job.imei,
    //       template: template,
    //       unscheduled: job.unscheduled,
    //       Vehicle: job.vehicle,
    //       vehicle: job.reg ? job.reg : '',
    //       CompletedDate: job.CompletedDate,
    //       startTime: job.startTime || null,
    //       endTime: job.endTime || null
    //     }
    //     console.log(obj)
    //     fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
    //     .set(obj)
    //     .then(() => {
    //       fireStore.collection('Jobs/').doc(doc).update({Status: 2, CompletedDate: job.CompletedDate})
    //       // Data has been successful so safe to remove from IDB
    //       dbPromise().then(function (db) {
    //         let tx = db.transaction('outbox', 'readwrite')
    //         let outboxStore = tx.objectStore('outbox')
    //         outboxStore.delete(parseInt(element))
    //       })
    //       .then(() => {
    //         this.snackbar = true
    //         this.snackbarText = 'Upload Successful'
    //         this.getImages()
    //         for (let deleteIndex in toDelete) {
    //           dbPromise().then(function (db) {
    //             let tx = db.transaction('imageStore', 'readwrite')
    //             let imageStore = tx.objectStore('imageStore')
    //             imageStore.delete(toDelete[deleteIndex])
    //           })
    //         }
    //         this.uploadFile()
    //         this.snackbar = true
    //         this.snackbarText = 'Finished Sending'
    //         this.sending = false
    //       })
    //       .catch(error => {
    //         console.log(error)
    //         this.snackbarText = 'Error updating status'
    //         this.snackbar = true
    //         this.sending = false
    //       })
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.snackbarText = 'Error setting completed job'
    //       this.snackbar = true
    //       this.sending = false
    //     })
    //   })
    //   .catch(reason => {
    //     console.log('promise failed')
    //     console.log(reason)
    //     this.snackbarText = 'Error uploading job'
    //     this.snackbar = true
    //     this.sending = false
    //   })
    // },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    }
  }
}
</script>



// WEBPACK FOOTER //
// UploadJobs.vue?2eb867f6